/**
 * Turns an array into an object
 * @param {Array} arr 
 * @param {string} key 
 * @returns Map object with key as key and passed in items as values
 */
export function mapifyArray(arr, key) {
    if (arr === undefined || arr === null) return arr;
    const map = {};
    for (const item of arr) {
        map[item[key]] = item;
    }
    return map;
}